import { render, staticRenderFns } from "./file-uploader.vue?vue&type=template&id=68e72712&scoped=true&"
import script from "./file-uploader.vue?vue&type=script&lang=js&"
export * from "./file-uploader.vue?vue&type=script&lang=js&"
import style0 from "./file-uploader.vue?vue&type=style&index=0&id=68e72712&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e72712",
  null
  
)

export default component.exports